/**
 * Page header component.
 */

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
}

export function PageHeader({ title, subtitle, actions }: PageHeaderProps) {
  return (
    <div className="flex-1 mb-24">
      <div className="flex items-center justify-between">
        <div>
          <h1 style={{ margin: 0, fontSize: '22px', fontWeight: 700 }}>{title}</h1>
          {subtitle && (
            <p className="muted text-sm" style={{ margin: '4px 0 0' }}>
              {subtitle}
            </p>
          )}
        </div>
        {actions && <div className="row gap-8">{actions}</div>}
      </div>
    </div>
  );
}
